import { Box, Breadcrumbs, Link, Typography } from "@mui/material";

import React from "react";
import { ColorIcon } from "../../common/Icons";
import { colors } from "../../../styles";
import { GOI_WEB_URL } from "../../../constants";
import { ClickEventType } from "../../../types";
import { customEvent } from "../../../utils";

interface BreadCrumbProps {
  href: string;
  text: string;
  event?: ClickEventType;
}

export function ATypeBreadCrumb({
  firstItem,
  secondItem,
  thirdItem,
  goiHomeEvent,
}: {
  firstItem: BreadCrumbProps;
  secondItem?: BreadCrumbProps;
  thirdItem?: BreadCrumbProps;
  goiHomeEvent?: ClickEventType;
}) {
  const onClickEvent = (event: ClickEventType) => {
    customEvent(event);
  };

  const onClickGoiHomeEvent = () => {
    if (goiHomeEvent) {
      customEvent(goiHomeEvent);
    }
  };

  return (
    <Box width="100%" padding="0 20px">
      <Breadcrumbs
        separator={
          <ColorIcon name="thin-arrow-right" size={25} color={colors.gray100} />
        }
        sx={{
          ["& .MuiBreadcrumbs-separator"]: { margin: 0 },
        }}
      >
        <Link
          underline="hover"
          color="inherit"
          href={`${GOI_WEB_URL}?utm_source=dogsound`}
          onClick={onClickGoiHomeEvent}
        >
          <ColorIcon
            name="home-fill"
            size={26}
            color={colors.gray600}
          />
        </Link>
        {firstItem && (
          <Link
            underline="hover"
            color="inherit"
            href={firstItem.href}
            onClick={() => onClickEvent(firstItem?.event as ClickEventType)}
          >
            <Typography className="body_14_m gray600" sx={{ fontSize: '14px !important' }}>
              {firstItem.text}{" "}
            </Typography>
          </Link>
        )}
        {secondItem && (
          <Link
            underline="hover"
            color="inherit"
            href={secondItem.href}
            onClick={() => onClickEvent(secondItem?.event as ClickEventType)}
          >
            <Typography className="body_14_m gray600" sx={{ fontSize: '14px !important' }}>
              {secondItem.text}
            </Typography>
          </Link>
        )}
        {thirdItem && (
          <Link
            underline="hover"
            color="inherit"
            href={thirdItem.href}
            onClick={() => onClickEvent(thirdItem?.event as ClickEventType)}
          >
            <Typography className="body_14_m gray600" sx={{ fontSize: '14px !important' }}>
              {thirdItem.text}
            </Typography>
          </Link>
        )}
      </Breadcrumbs>
      <Box width="100%" height="1px" style={{ background: colors.gray100 }} />
    </Box>
  );
}
